import Cpp from './components/Cpp';

export default Cpp;
